module.exports = __webpack_public_path__ + "static/media/bg-3.6ecf79db.jpg";